import { TargetFinderTab } from '../intel/TargetFinderTab';
import type { TargetFinderShellProps } from '../../pages/TargetFinder';

/**
 * SF-171 Component 4: thin wrapper — renders `TargetFinderTab.tsx` unchanged. Desktop gets zero
 * visual/interaction change; this shell exists only to satisfy the `Desktop{X}Shell`/
 * `Mobile{X}Shell` naming convention now that `TargetFinder.tsx` is platform-split for the first
 * time.
 */
export function DesktopTargetFinderShell({
  worldId, provinceId, results, onResults, expandedId, onExpandedId,
}: TargetFinderShellProps) {
  return (
    <TargetFinderTab
      worldId={worldId}
      provinceId={provinceId}
      results={results}
      onResults={onResults}
      expandedId={expandedId}
      onExpandedId={onExpandedId}
    />
  );
}
